import { SxProps, Theme } from '@mui/material';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

// Stroke-only icon -- overrides SvgIcon's own default fill:currentColor,
// which would otherwise solid-fill these shapes instead of just outlining them.
const customStyles = {
  icon: { fill: 'none' },
} satisfies Record<string, SxProps<Theme>>;

export function RowsOutline(props: SvgIconProps) {
  const { color = 'currentColor', ...rest } = props;
  return (
    <SvgIcon
      {...rest}
      viewBox='0 0 24 24'
      sx={customStyles.icon}
    >
      <line
        x1='4'
        y1='4'
        x2='4'
        y2='20'
        stroke={color}
        strokeWidth='1.6'
        strokeLinecap='round'
      />
      <rect
        x='8'
        y='5'
        width='13'
        height='5.5'
        rx='1.5'
        stroke={color}
        strokeWidth='1.6'
      />
      <rect
        x='8'
        y='13.5'
        width='9'
        height='5.5'
        rx='1.5'
        stroke={color}
        strokeWidth='1.6'
      />
    </SvgIcon>
  );
}
